<section class='applied-filters'>
  @if (isMobile || appliedFilters?.length) {
    <div class='applied-filters__header'>
      <span class='applied-filters__title' i18n='@@filters__title'>Filtros</span>
      @if (appliedFilters?.length) {
        <span class='applied-filters__remove' (click)='allFiltersRemoved.emit()'>
          <mb-icon icon='trash'></mb-icon>
          <span i18n='@@applied-filters__remove'>Borrar todos</span>
        </span>
      }
    </div>
  }
  <div class='applied-filters__list'>
    <mb-chips>
      @for (filter of appliedFilters; track filter) {
        @if (!filter?.values) {
          <mb-chip (dismiss)='changeFilter(filter.type, filter)'>
            {{ filter?.description }}
          </mb-chip>
        } @else {
          @for (item of filter?.values; track item) {
            <mb-chip (dismiss)='changeFilter(filter.type, item)'>
              @if (filter.type === 'PRICE_RANGE') {
                {{ (item?.from || item?.min) | currency: '$' :'code' }}
                - {{ (item?.to || item?.max) | currency: '$' :'code' }}
              } @else {
                {{ item?.description }}
              }
            </mb-chip>
          }
        }
      }
    </mb-chips>
  </div>
</section>
